// extracted by mini-css-extract-plugin
module.exports = {"text-substitute":"style_text-substitute__TL3L5","coin-icon":"style_coin-icon__AFHZs"};